(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Hero Carousel — sync slide duration with video length.
   *
   * When "Match video length" is enabled, slides with video auto-advance
   * when the video ends; non-video slides use the configured transition speed.
   */
  for (const heroSection of document.querySelectorAll('.hero-section[data-match-video-length="true"]')) {
    const slideshowEl = heroSection.querySelector('slideshow-component');
    if (!slideshowEl) continue;

    const fallbackSpeed = parseInt(heroSection.dataset.slideSpeed, 10) || 5;

    const syncAutoplayToVideo = () => {
      const currentSlide = slideshowEl.slides?.[slideshowEl.current];
      if (!currentSlide) return;

      const video = currentSlide.querySelector('video');

      if (video && video.readyState >= 1) {
        slideshowEl.suspend();
        const duration = Math.ceil(video.duration);
        slideshowEl.setAttribute('autoplay', String(duration));
        slideshowEl.play(duration * 1000);
      } else if (video) {
        slideshowEl.suspend();
        video.addEventListener('loadedmetadata', () => {
          const duration = Math.ceil(video.duration);
          slideshowEl.setAttribute('autoplay', String(duration));
          slideshowEl.play(duration * 1000);
        }, { once: true });
      } else {
        slideshowEl.setAttribute('autoplay', String(fallbackSpeed));
        slideshowEl.play(fallbackSpeed * 1000);
      }
    };

    slideshowEl.addEventListener('slideshow:select', syncAutoplayToVideo);

    if (slideshowEl.slides?.length) {
      syncAutoplayToVideo();
    }
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  class MarqueeTrack extends HTMLElement {
    /** @type {string|null} */
    _originalHTML = null;

    /** @type {ResizeObserver|null} */
    _resizeObserver = null;

    /** @type {boolean} */
    _fillScheduled = false;

    async connectedCallback() {
      await document.fonts?.ready;
      await this._waitForImages();
      requestAnimationFrame(() => this.fill());

      const container = this.closest('.marquee') || this;
      this._resizeObserver = new ResizeObserver(() => this._scheduleFill());
      this._resizeObserver.observe(container);
    }

    disconnectedCallback() {
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
    }

    _scheduleFill() {
      if (this._fillScheduled) return;
      this._fillScheduled = true;
      requestAnimationFrame(() => {
        this._fillScheduled = false;
        this.fill();
      });
    }

    _waitForImages() {
      const images = this.querySelectorAll('img');
      const promises = [...images].map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      });
      return Promise.all(promises);
    }

    fill() {
      const contents = this.querySelectorAll('.marquee__content');
      if (contents.length < 2) return;

      const primary = contents[0];
      const duplicate = contents[1];
      const containerWidth = this.closest('.marquee')?.offsetWidth || window.innerWidth;

      if (!this._originalHTML) {
        this._originalHTML = primary.innerHTML;
      }

      primary.innerHTML = this._originalHTML;

      const groups = [...primary.querySelectorAll(':scope > .marquee__group')];
      if (!groups.length) return;

      while (primary.scrollWidth < containerWidth * 2) {
        for (const group of groups) {
          primary.appendChild(group.cloneNode(true));
        }
      }

      duplicate.innerHTML = primary.innerHTML;
    }
  }

  if (!customElements.get('marquee-track')) {
    customElements.define('marquee-track', MarqueeTrack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !Shopify.designMode) return;
  try {
    
  const grid = document.querySelector('[data-press-grid]');
  const loadMoreBtn = document.querySelector('[data-press-load-more]');

  if (grid && loadMoreBtn) {
    const visibleItems = parseInt(grid.dataset.visibleItems, 10) || 16;
    const cards = Array.from(grid.children);

    if (cards.length > visibleItems) {
      cards.forEach((card, i) => {
        if (i >= visibleItems) card.classList.add('press-card--hidden');
      });
      loadMoreBtn.style.display = '';

      let shown = visibleItems;

      loadMoreBtn.addEventListener('click', () => {
        const nextBatch = cards.slice(shown, shown + visibleItems);
        nextBatch.forEach((card, i) => {
          card.classList.remove('press-card--hidden');
          card.classList.add('press-card--revealing');
          card.style.animationDelay = `${i * 50}ms`;
          card.addEventListener('animationend', () => {
            card.classList.remove('press-card--revealing');
            card.style.animationDelay = '';
          }, { once: true });
        });

        shown += nextBatch.length;
        if (shown >= cards.length) loadMoreBtn.style.display = 'none';
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
